"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export type FaqItem = {
  question: string;
  answer: string;
};

export default function GenericFaqAccordion({ faqs }: { faqs: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="flex flex-col">
      {faqs.map((faq, index) => (
        <div key={index} className="border-b border-gray-200">
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="flex w-full items-center justify-between py-4 md:py-5 text-left transition-colors hover:text-gray-600"
            aria-expanded={openIndex === index}
          >
            <span className="text-[15px] md:text-base font-normal text-black">
              {faq.question}
            </span>
            <ChevronDown
              className={`h-5 w-5 flex-shrink-0 text-black transition-transform duration-200 ${
                openIndex === index ? "rotate-180" : ""
              }`}
            />
          </button>

          {openIndex === index && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              transition={{ duration: 0.2 }}
              className="overflow-hidden"
            >
              <p className="pb-4 md:pb-5 text-[13.5px] md:text-sm leading-relaxed text-gray-600">
                {faq.answer}
              </p>
            </motion.div>
          )}
        </div>
      ))}
    </div>
  );
}
